import Vue from 'vue'
import Vuex from 'vuex'
import language from "./modules/language"; // 注入语言翻译模块

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    language,
  }
})
